<template>
    <b-modal
        title-tag="h2"
        title="Approval Required"
        :lazy="true"
        :visible="$store.state.billingLockModal.isOpen"
        @ok="proceed"
        @close="close"
        @hide="close"
    >
        <b-alert variant="warning" :show="errorMessage !== ''">
            <i class="cus-error"></i>
            {{ errorMessage }}
        </b-alert>

        <p class="message">
            The change you are requesting requires administrator approval
            because it affects historical records. Please enter the
            administrator password to continue.
        </p>

        <b-form-group
            label-cols="4"
            label="Approved By:"
            label-for="approvedBy"
        >
            <b-select
                text-field="label"
                value-field="id"
                :disabled="isLoading"
                v-model="approvedBy"
                :options="adminList"
            />
        </b-form-group>

        <b-form-group label-cols="4" label="Password:" label-for="password">
            <b-form-input
                type="password"
                v-model="password"
                placeholder="Enter a password (required)"
                :disabled="isLoading"
                autocomplete="off"
            ></b-form-input>
        </b-form-group>

        <template v-slot:modal-footer>
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isLoading"
                variant="primary"
                @click="proceed"
                :disabled="password === ''"
            >
                Approve
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Client from "@/services/client";
import Loader from "@/module/commons/loader";
import AccountServices from "@/services/account";

export default {
    name: "clientModalBillingLock",
    components: {
        Loader
    },
    data() {
        return {
            isLoading: false,
            errorMessage: "",
            password: ""
        };
    },
    computed: {
        adminList() {
            return this.$store.state.billingLockModal.administratorList;
        },
        approvedBy: {
            set(value) {
                this.$store.commit("updateBillingLockModal", {
                    selectedAdministrator: value
                });
            },
            get() {
                return this.$store.state.billingLockModal.selectedAdministrator;
            }
        }
    },
    methods: {
        close() {
            this.$store.commit("hideBillingLockModal");
        },
        async proceed() {
            try {
                const res = await AccountServices.unlockBillingLock(
                    this.password
                );

                if (res.message && res.message.code === 200) {
                    this.$store.dispatch("proceedBillingLock");
                } else {
                    this.password = "";
                    throw new Error(res.resource);
                }
            } catch (error) {
                this.isLoading = false;
                this.errorMessage = error.message;
            }
        }
    }
};
</script>

<style scoped>
.message {
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
}
</style>
